export default (ctx, key) => {
  let strings = {
    "something_went_wrong": "Something went wrong. Please try again later.",
    "validation_rule_member": "Enter email, phone number or username of the person you want to invite.",
    "validation_rule_organization": "Organizations can only hold lowercase characters, digits , dashes and contain 3 up to 50 characters.",
    "validation_rule_globalid": "Please enter an existing organization.",
    "validation_rule_email": "Enter a valid email address",
    "validation_rule_required_field": "Required field",
    "validation_rule_https_url": "Enter a valid callback url",
    "validation_rule_min_length": "Needs to contain at least 3 characters",
    "validation_rule_password": "your password must be at least 8 characters long and contain at least one uppercase and one lowercase letter, one special character, and one numeric character",
    "validation_rule_token": "Label should be at least 3 (only lower case) characters"
  }
  return strings[key]
}
